var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSideBarResearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8380_20962)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 1.00751V2.35084H3.47019L4.79486 3.67552H7.44421V1.00751H2.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.98877 9.01153V3.11578H3.24632L4.55234 4.4218H8.93683V9.01153H0.98877Z",
    fill: "#009A7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.93914 3.43296H8.41449V0.621292C8.41449 0.278369 8.1365 0 7.7932 0H2.13254C1.78962 0 1.51125 0.277995 1.51125 0.621292V2.08963H0.986604C0.441808 2.08963 0 2.53144 0 3.07623V9.0134C0 9.55819 0.441808 10 0.986604 10H8.93877C9.48356 10 9.92537 9.55819 9.92537 9.0134V4.41957C9.92537 3.87477 9.48356 3.43296 8.93877 3.43296H8.93914ZM2.70532 1.3508C2.70532 1.26423 2.77548 1.19407 2.86205 1.19407H7.06332C7.14989 1.19407 7.22005 1.26423 7.22005 1.3508V3.43296H4.99123C4.91623 3.43296 4.84384 3.40311 4.79085 3.35012L3.75835 2.31762C3.61245 2.17172 3.41468 2.09 3.2087 2.09H2.70495V1.35117L2.70532 1.3508ZM8.73167 8.55741C8.73167 8.69473 8.62047 8.8063 8.48278 8.8063H1.44296C1.30565 8.8063 1.19407 8.6951 1.19407 8.55741V3.53259C1.19407 3.39528 1.30527 3.2837 1.44296 3.2837H2.91914C2.99414 3.2837 3.06653 3.31356 3.11952 3.36654L4.15202 4.39904C4.29792 4.54495 4.49569 4.62667 4.70167 4.62667H8.48278C8.6201 4.62667 8.73167 4.73786 8.73167 4.87556V8.55741Z",
    fill: "#231E1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8380_20962"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideBarResearchIcon);
export default __webpack_public_path__ + "static/media/SideBarResearchIcon.936835167793d4ff9bc63f024924429e.svg";
export { ForwardRef as ReactComponent };